import * as gleam from './gleam.mjs'

export const timestamp = () => Date.now()

export function coerceEventDetails(event) {
  event.stopPropagation()
  return event.detail
}

export function subscribeDOMClick(dispatch) {
  // prettier-ignore
  const run = () => {
    try { dispatch() }
    catch (e) { console.log(e) }
  }
  setTimeout(() => document.addEventListener('click', run, { once: true }), 100)
  return () => document.removeEventListener('click', run)
}

export function preventDefault(event) {
  event.preventDefault()
}

export function blurTarget(event) {
  event.preventDefault()
  event.target?.blur()
}

export function toggleDomFreeze() {
  const elements = document.getElementsByTagName('*')
  if (document.body.style.getPropertyValue('overflow')) {
    delete window.frozen
    document.body.style.removeProperty('overflow')
    for (const element of elements) {
      if (element.style.getPropertyValue('overflow'))
        element.style.removeProperty('overflow')
    }
  } else {
    document.body.style.setProperty('overflow', 'hidden')
    window.frozen = true
    for (const element of elements) {
      const styles = window.getComputedStyle(element)
      if (
        styles.overflow.includes('auto') ||
        styles.overflow.includes('scroll')
      ) {
        element.style.setProperty('overflow', 'hidden')
      }
    }
  }
}

export function stopDomFreeze() {
  delete window.frozen
  const elements = document.getElementsByTagName('*')
  if (document.body.style.getPropertyValue('overflow')) {
    document.body.style.removeProperty('overflow')
    for (const element of elements) {
      if (element.style.getPropertyValue('overflow'))
        element.style.removeProperty('overflow')
    }
  }
}

export function platform() {
  if (typeof 'window' === undefined) return new gleam.Error()
  if (!('platform' in window.navigator)) return new gleam.Error()
  return new gleam.Ok(window.navigator.platform)
}

export function clipboardCopy(text) {
  return navigator.clipboard.writeText(text)
}

export function overflow(value) {
  if (window.frozen) return 'hidden'
  return value
}
